
<template>
  <div :class="['preview-image', size, `col${isMobile ? '-2' : ''}`]">
    <div
      v-if="$slots.overlay"
      class="overlay">
      <slot name="overlay"/>
    </div>
  </div>
</template>

<script setup>
import useScreenSize from '@shared/composables/screenSize.js'

defineProps({
  size: {
    type: String,
    default: 'auto',
    validator: value => ['auto', 'xx-large', 'x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})

const { isMobile } = useScreenSize()
</script>

<style lang="scss" scoped>
@import './PreviewImage.scss';

.preview-image {
  @include placeholder-loading-animation;
}
</style>
